import { Content } from './content.model';

export abstract class ContentList {
  items: Content[];
  total: number;
}
